export const ROLE_OPTIONS = [
  { value: 'teacher', label: 'Teacher' },
  { value: 'teacher_supervisor', label: 'Teacher supervisor' },
  { value: 'teacher_admin', label: 'Teacher admin' },
  { value: 'sales', label: 'Sales' },
  { value: 'sales_supervisor', label: 'Sales supervisor' },
  { value: 'country_manager', label: 'Country Manager' },
  { value: 'finance_user', label: 'Finance' },
  { value: 'finance_supervisor', label: 'Finance supervisor' },
  { value: 'finance_admin', label: 'Finance admin' },
  { value: 'batch_supervisor', label: 'Batch supervisor' },
  { value: 'batch_admin', label: 'Batch admin' },
  { value: 'parent_feedback_agent', label: 'Feedback' },
  { value: 'admin', label: 'Admin' },
];

const GAP_LABELS = {
  'Payee type': 'Employee or contractor',
  'Display name': 'Name on the payslip',
  'Date of joining': 'Joining date',
  PAN: 'PAN',
  'Bank account name, number, IFSC, and bank name': 'Bank account',
  Designation: 'Job title',
  'Acknowledged current work location': 'Work location confirmed',
  'Working pattern': 'Weekly off and working hours',
  'Holiday calendar': 'Holiday list',
  'Leave template': 'Leave list',
  'Agreed pay': 'Salary',
  'Salary lines that add up to the agreed total': 'Salary lines that add up',
  'PF choice': 'Provident fund: yes or no',
  UAN: 'UAN',
  'TDS section': 'Tax section for contractors',
};

const STATUTE_LABELS = {
  pf: 'Provident fund',
  esi: 'ESI',
  pt: 'Professional tax',
  lwf: 'Labour welfare fund',
  tds_salary: 'Income tax on salary',
  tds_professional_fee: 'Tax on professional fees',
  bonus: 'Statutory bonus',
  gratuity: 'Gratuity',
};

const LEAVE_STATUS = {
  waiting: 'Waiting',
  approved: 'Approved',
  rejected: 'Not approved',
  cancelled: 'Cancelled',
};

const WEEK_STATUS = {
  draft: 'Not sent',
  submitted: 'Waiting',
  approved: 'Approved',
  rejected: 'Sent back',
  reopened: 'Opened again',
};

export function roleLabel(role) {
  const found = ROLE_OPTIONS.find((row) => row.value === role);
  if (found) return found.label;
  return String(role || '').replace(/_/g, ' ');
}

export function gapLabel(item) {
  return GAP_LABELS[item] || item;
}

export function statuteLabel(code) {
  return STATUTE_LABELS[code] || String(code || '').replace(/_/g, ' ');
}

export function leaveStatusLabel(status) {
  return LEAVE_STATUS[status] || status;
}

export function weekStatusLabel(status) {
  return WEEK_STATUS[status] || status;
}
